import React from 'react';
import getCarParkDistance from '../../../../global/helpers/getDistanceFomGeoPoints';

const InfoWindow = (props) => {
  if (props.name == undefined) {
    return null;
  }

  const getParkingUrl = () => {
    if (
      $('body').hasClass('en-NZ') &&
      props.monthlyParkingServiceIsAvailable &&
      props.cpms
    ) {
      return props.cpms.replace('{0}', props.cpmsCarparkCode || '');
    }
    return props.url;
  };

  const renderIcons = (services) => {
    return (
      <div className='option-wrap d-flex mt-3 mb-4'>
        {services.indexOf('book a bay') > -1 && (
          <div className='text-center'>
            <div
              className='option-icon book-online mb-1'
              style={{
                backgroundImage:
                  props.iconBookOnline && `url(${props.iconBookOnline})`,
              }}
            ></div>
            <div className='fsp-12'>
              {props.iconLabelBookOnline || 'Book Online'}
            </div>
          </div>
        )}
        {services.indexOf('monthly') > -1 && (
          <div className='text-center'>
            <div
              className='option-icon monthly-parking mb-1'
              style={{
                backgroundImage:
                  props.iconMonthlyParking &&
                  `url(${props.iconMonthlyParking})`,
              }}
            ></div>
            <div className='fsp-12'>
              {props.iconLabelMonthlyParking || 'Monthly Parking'}
            </div>
          </div>
        )}
        {services.indexOf('wilson one') > -1 && (
          <div className='text-center'>
            <div
              className='option-icon wilson-one mb-1'
              style={{
                backgroundImage:
                  props.iconParkingCard && `url(${props.iconParkingCard})`,
              }}
            ></div>
            <div className='fsp-12'>
              {props.iconLabelParkingCard || 'Parking Card'}
            </div>
          </div>
        )}
        {services.indexOf('ev charging') > -1 && (
          <div className='text-center'>
            <div
              className='option-icon ev-charger mb-1'
              style={{
                backgroundImage:
                  props.iconEvCharger && `url(${props.iconEvCharger})`,
              }}
            ></div>
            <div className='fsp-12'>
              {props.iconLabelEvCharger || 'EV Charging'}
            </div>
          </div>
        )}
      </div>
    );
  };

  const handleClick = (event) => {
    event.stopPropagation();
  };

//   const isElevateOnly = props.carParkFeature.includes('Elevate Only');
  const isElevateOnly = () => {
	const prepayCarParkFeature = window.prepayCarParkFeature; // E.g: 'Epark,Elevate Only,Prepay Online'
	if (!props.carParkFeature || !prepayCarParkFeature || props.carParkFeature.length === 0) return;
	const prepayFeaturesArray = prepayCarParkFeature.split(',');
	return prepayFeaturesArray.every((feature) => props.carParkFeature.includes(feature));
  };
  const handleOpenPrepayModal = (event) => {
    event.preventDefault();
    const prepayModal = document.getElementById('prepayModal');
    if (prepayModal) {
      if (prepayModal.classList.contains('hidden')) {
        prepayModal.classList.remove('hidden');
      }
    }
  };

  return (
    <div
      className={`map-infoWindow ${props.highlightClass}`}
      onClick={handleClick}
    >
      <div className='map-infoWindow-wrapper rounded p-3'>
        <div className='fs-1 map-infoWindow-name d-flex'>
          <div className='flex-1'>{props.name}</div>
          <div
            className='icon-close'
            style={{color: 'black'}}
            onClick={props.clearInfo}
          ></div>
        </div>
        <div className='text address tag-feature'>{props.location.address}</div>
        {props.walkingTime && (
          <div className='text py-1'>{props.walkingTime}</div>
        )}
        <div className='text py-1'>{`${getCarParkDistance(
          props.lat,
          props.lng,
          props.destination.lat,
          props.destination.lng
        ).toFixed(2)} km direct`}</div>
        {props.fromPrice && (
          <div className='price pb-2'>
            <span>From</span>
            {/* {props.rates[0] !== undefined && (
						<span className="font-weight-bold ml-2">${props.rates[0].rates[0].price}</span>
					)} */}
            <span className='font-weight-bold ml-2'>${props.fromPrice}</span>
          </div>
        )}

        {/* icon sets */}
        {props.services && renderIcons(props.services)}
        {/* button sets */}
        <div className='d-flex align-items-center justify-content-flex-start'>
          {props.type === 'monthly' && (
            <a
              target={props.ctatarget || '_blank'}
              href={`${getParkingUrl()}`}
              className='btn btn-primary text book-btn w-33'
            >
              {props.ctaText}
            </a>
          )}
          {props.type === 'bookonline' && (
            <a
              href={
                isElevateOnly()
                  ? 'javscript:void(0)'
                  : '#simpleLocationSearchContainer'
              }
              onClick={(e) => {
                if (isElevateOnly()) {
                  handleOpenPrepayModal(e);
                } else {
                  props.setBookOnlinePark(props.name);
                  props.setBookOnlineState(
                    props.location.region.state.abbreviation
                  );
                  props.setCarParkCode(props.carParkNumber);
                }
              }}
              className='btn btn-primary text book-btn w-33'
            >
              {props.ctaText}
            </a>
          )}
          {props.carParkFeature.includes('Book a Bay') &&
            props.type != 'monthly' &&
            props.type != 'bookonline' && (
              <a
                target={props.ctatarget}
                href={`${
                  isElevateOnly()
                    ? 'javascript:void(0)'
                    : props.formatBookUrl(props.carParkNumber)
                }`}
                className='btn btn-primary text book-btn w-33'
                onClick={(e) => isElevateOnly() && handleOpenPrepayModal(e)}
              >
                {props.ctaText}
              </a>
            )}
          <a href={`${props.url}`} className='text text-center w-33'>
            View Details
          </a>
          <a
            href={`https://www.google.com/maps/place/${props.location.address}`}
            // onClick={props.showCarParkPath}
            target='_blank'
            className='text text-center book-btn w-33'
          >
            Get Directions
          </a>
        </div>
      </div>
    </div>
  );
};

export default InfoWindow;
